import React from 'react';
import ServiceLandingPage from './ServiceLandingPage';
import { SERVICES_PAGE, buildServicesStructuredData } from '../data/servicesPage';

const ServicesPage = () => (
  <ServiceLandingPage
    seoPath="/services"
    pageData={SERVICES_PAGE}
    buildStructuredData={buildServicesStructuredData}
  />
);

export default ServicesPage;
